import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ZorroTableComponent } from '../custom-table/zorro-table.component';
import { NoDataComponent } from '../no-data/no-data.component';

@Component({
  selector: 'app-test-case-performance-view',
  standalone: true,
  imports: [CommonModule, ZorroTableComponent, NoDataComponent],
  templateUrl: './test-case-performance-view.component.html',
  styleUrl: './test-case-performance-view.component.scss',
})
export class TestCasePerformanceViewComponent implements OnChanges {
  @Input() columns: any[] = [];
  @Input() data: any[] = [];
  @Input() config: any = {};
  @Input() metric: any = {};

  tableColumns: any[] = [];
  tableRows: any[] = [];
  tableOptions: any = { pageSize: 4, showPagination: true };

  get title(): string {
    return this.metric?.metricDisplayName ?? '';
  }

  get totalCount(): number {
    return this.tableRows.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] || changes['columns'] || changes['config'] || changes['metric']) {
      this.build();
    }
  }

  private build(): void {
    const pageSize = this.metric?.meta?.[0]?.maxRows
      ?? this.config?.maxRows
      ?? 4;

    this.tableOptions = { pageSize, showPagination: true };

    this.tableColumns = (this.columns ?? []).map(col => ({
      display_name: col.display_name,
      key: col.key
    }));

    this.tableRows = (Array.isArray(this.data) ? this.data : []).map(
      (row, index) => ({ ...row, id: index + 1 }),
    );
  }
}
